import { useState } from "react";
import { Trash2, Loader2 } from "lucide-react";
import { api, describeAxiosError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel } from "@/components/ui/alert-dialog";
import { monthLabel } from "./helpers";

export const DeleteTargetDialog = ({ record, onClose, onDeleted }) => {
  const [busy, setBusy] = useState(false), [error, setError] = useState("");
  const remove = async () => {
    if (busy) return;
    setBusy(true); setError("");
    try { await api.delete(`/performance/${record.id}`); onDeleted(); }
    catch (e) { setError(describeAxiosError(e)); }
    finally { setBusy(false); }
  };
  return <AlertDialog open onOpenChange={(open) => { if (!open && !busy) onClose(); }}>
    <AlertDialogContent className="bg-white w-[calc(100%-2rem)] rounded-lg" data-testid="delete-target-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle data-testid="delete-target-title">Delete monthly target?</AlertDialogTitle>
        <AlertDialogDescription data-testid="delete-target-description">
          This removes {record.employee_name}’s targets and recorded achievements for {monthLabel(record.month)}. Financial-year achievements will be recalculated. Their annual targets remain unchanged. This cannot be undone.
        </AlertDialogDescription>
      </AlertDialogHeader>
      {error && <p role="alert" className="text-sm text-red-700" data-testid="delete-target-error">{error}</p>}
      <AlertDialogFooter>
        <AlertDialogCancel disabled={busy} data-testid="delete-target-cancel">Cancel</AlertDialogCancel>
        <Button variant="destructive" disabled={busy} onClick={remove} data-testid="delete-target-confirm">{busy ? <Loader2 className="animate-spin" /> : <Trash2 />}Delete record</Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>;
};